export const mapInvoiceForList = (invoice = {}) => ({
  ...invoice,
  invoice_id: invoice._id || invoice.invoice_id,
  invoice_date: invoice.invoiceDate || invoice.invoice_date || "",
  invoice_no: invoice.invoiceNumber || invoice.invoice_no || "",
  invoice_note: invoice.invoiceNote || invoice.invoice_note || "",
  net_pass_quantity: invoice.netPass ?? invoice.net_pass_quantity ?? 0,
  total_price_without_sale_tax:
    invoice.invoiceTotalExcludeTax ?? invoice.total_price_without_sale_tax ?? 0,
  total_sale_tax_payable:
    invoice.totalTaxRate ?? invoice.total_sale_tax_payable ?? 0,
  total_value_include_sale_tax:
    invoice.invoiceTotalIncludeTax ?? invoice.total_value_include_sale_tax ?? 0,
  buyer_company_name:
    invoice.buyerCompanyName || invoice.buyer_company_name || "",
  company_id: invoice.companyId || invoice.company_id,
  cloth_return_id: invoice.dispatchId || invoice.cloth_return_id,
});

export const mapInvoicesForList = (invoices = []) =>
  (Array.isArray(invoices) ? invoices : []).map(mapInvoiceForList);
